import { AdminApiService } from '../services/general';
import type { CampaignCreate, CampaignUpdate } from '../services/general';

export type GetCampaignsFilters = { status?: string };
export type GetCampaignMonitoringFilters = { campaignId?: string };
export type CampaignCreatePayload = CampaignCreate;
export type CampaignUpdatePayload = CampaignUpdate;

export const getCampaigns = (
  filters: GetCampaignsFilters,
  page: PaginationType
) => {
  return AdminApiService.getCampaignsApiAdminCampaignsGet(
    filters.status,
    page.limit,
    page.offset
  );
};

export const getCampaignMonitoring = (
  filters: GetCampaignMonitoringFilters
) => {
  return AdminApiService.getCampaignMonitoringApiAdminCampaignMonitoringGet(
    filters.campaignId
  );
};

export const getCampaignMetrics = (filters: GetCampaignMonitoringFilters) => {
  return AdminApiService.getCampaignMetricsApiAdminCampaignMetricsGet(
    filters.campaignId
  );
};

export const addCampaign = (payload: CampaignCreatePayload) => {
  return AdminApiService.createCampaignApiAdminCampaignsPost(payload);
};
export const updateCampaign = (id: string, payload: CampaignUpdatePayload) => {
  return AdminApiService.updateCampaignApiAdminCampaignsCampaignIdPatch(
    id,
    payload
  );
};
export const deleteCampaign = (id: string) => {
  return AdminApiService.deleteCampaignApiAdminCampaignsCampaignIdDelete(id);
};

export type { CampaignResponse as CampaignType } from '../services/general';
export type { CampaignMonitoringResponse as CampaignMonitoringItemType } from '../services/general';
